var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    {
      staticClass: "page-not-found-background ta-c",
      attrs: { justify: "center" },
    },
    [
      _c("v-col", { attrs: { cols: "12" } }, [
        _c("img", {
          staticClass: "page-not-found",
          attrs: { src: _vm.ic_404_page_not_found },
        }),
      ]),
      _c("v-col", { attrs: { cols: "12" } }, [
        _c("label", { staticClass: "first-header header" }, [
          _vm._v("Oops... this page could not be found."),
        ]),
      ]),
      _c(
        "v-col",
        { attrs: { xl: "4", lg: "5", md: "7", sm: "10", xs: "10" } },
        [
          _c("label", { staticClass: "text" }, [
            _vm._v(
              "This page might have been removed or is temporarily unavailable. "
            ),
          ]),
        ]
      ),
      _c(
        "v-col",
        { staticClass: "ta-c pt-8", attrs: { cols: "12" } },
        [
          _c("smart-btn", {
            attrs: {
              to: "/customer/shipments",
              type: "primary",
              label: "Go back to previous page",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }